import { createFileRoute } from '@tanstack/react-router'
import { CarrerasScreen } from '@web/app/features/carreras'
import { GraduationCap } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/admin/careers')({
  component: CarrerasScreen,
  staticData: {
    metaRoute: {
      title: 'Carreras',
      order: 3,
      icon: GraduationCap,
    },
  },
})